import * as React from 'react';
import { LocationIcon } from '../../../components/Icons';

import { IKpData, TOfferCategory } from '../../../types/offer';
import { getVillageOfferCategoryLabel } from '../../../utils/getVillageOfferCategoryLabel';

import * as styles from './VillageInfoLink.css';

export interface IVillageLinkProps {
  kp?: IKpData | null;
  category?: TOfferCategory;
  onLinkClick?(): void;
}

export const VillageInfoLink = ({ kp, category, onLinkClick }: IVillageLinkProps) => {
  if (!kp) {
    return null;
  }
  const { name, url } = kp;
  const categoryLabel = getVillageOfferCategoryLabel(category);

  return (
    <div className={styles['container']}>
      <i className={styles['location_icon']}>
        <LocationIcon/>
      </i>
      {categoryLabel} находится в посёлке&nbsp;
      <a
        className={styles['link']}
        href={url}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          e.stopPropagation();

          if (onLinkClick) {
            onLinkClick();
          }
        }}
        target="_blank"
      >
        «{name}»
      </a>
    </div>
  );
};
